/*
 * Created by Joseph.Saliba on 3/20/15.
 */
import { Factory } from '../../services/Factory';

namespace app.directives.controls {
    export interface IEditableFieldScope extends angular.IScope {
        ngModel: any;
        value: string;
        editMode: boolean;
        onBlur: () => void;
        onKeyPress: (event: KeyboardEvent) => void;
    }

    export interface IEditableFieldAttributes extends angular.IAttributes {
        iioEditableField: string;
        iioEditableFieldService: string;
        iioEditableFieldExistingItems?: string;
        iioEditableFieldEmptyMessage?: string;
        iioEditableFieldDuplicateMessage?: string;
    }

    export class EditableFieldService implements angular.IDirective {
        public controller: () => void;

        constructor() {
            this.controller = () => {};
        }
    }

    export class EditableField implements angular.IDirective {
        public restrict: string = 'A';
        public link: (scope: IEditableFieldScope, element: angular.IAugmentedJQuery, attrs: IEditableFieldAttributes) => void;
        public template: string;
        public scope = { ngModel: '=' };
        public replace: boolean = false;
        public require: string[] = ["ngModel", "iioEditableFieldService"];

        constructor($injector: angular.auto.IInjectorService = null, notificationService: app.services.INotificationService = null) {
            this.template = "<input style='width:100px' ng-keypress='onKeyPress($event)' ng-model='value' ng-blur='onBlur()' ng-show='editMode'><span ng-hide='editMode'>{{value}}</span><i class='fas fa-pencil-alt text-muted iio-inline-edit-icon' ng-hide='editMode' ng-click='editMode = true'></i>";
            this.link = (scope: IEditableFieldScope, element: angular.IAugmentedJQuery, attrs: IEditableFieldAttributes) => {
                scope.value = scope.ngModel[attrs.iioEditableField];
                scope.editMode = false;

                const trim = (val: string): string => ((val || "") as string).trim();

                const getExistingItems = (): any[] => {
                    if (attrs.iioEditableFieldExistingItems) {
                        let s: any = scope;
                        while (s) {
                            try {
                                const result = s.$eval(attrs.iioEditableFieldExistingItems);
                                if (angular.isArray(result) && result.length > 0) return result;
                            } catch (e) { }
                            s = s.$parent;
                        }
                    }

                    if (attrs.iioEditableFieldService === "CollectionService") {
                        const collections: any[] = [];
                        let s: any = scope;
                        while (s) {
                            ["collections", "processingCollections", "collectionsSorted", "processingCollectionsSorted"].forEach(prop => {
                                if (angular.isArray(s[prop])) collections.push(...s[prop]);
                            });
                            s = s.$parent;
                        }
                        return collections;
                    }

                    return [];
                };

                const showError = (title: string, desc: string) => {
                    notificationService.addError({ title, description: desc, timeout: 5000 });
                };

                const revertAndClose = () => {
                    scope.value = scope.ngModel[attrs.iioEditableField];
                    scope.editMode = false;
                };

                const isDuplicate = (newValue: string): boolean => {
                    const loweredName = newValue.toLowerCase();
                    const currentId = scope.ngModel?.id;
                    return _.some(getExistingItems(), (item: any) =>
                        item && item.id !== currentId && trim(item[attrs.iioEditableField]).toLowerCase() === loweredName
                    );
                };

                scope.onKeyPress = (event: KeyboardEvent) => {
                    if (event?.keyCode === 13) {
                        event.preventDefault();
                        scope.onBlur();
                    }
                };

                scope.onBlur = () => {
                    const originalValue = trim(scope.ngModel[attrs.iioEditableField]);
                    const updatedValue = trim(scope.value);

                    if (!updatedValue) {
                        showError("Invalid name", attrs.iioEditableFieldEmptyMessage || "Name cannot be empty.");
                        revertAndClose();
                        return;
                    }

                    if (updatedValue.toLowerCase() === originalValue.toLowerCase()) {
                        revertAndClose();
                        return;
                    }

                    if (isDuplicate(updatedValue)) {
                        showError("Duplicate name", attrs.iioEditableFieldDuplicateMessage || "That name already exists.");
                        revertAndClose();
                        return;
                    }

                    scope.value = scope.ngModel[attrs.iioEditableField] = updatedValue;

                    ($injector.get(attrs.iioEditableFieldService) as any).AsResource(scope.ngModel).$update(
                        () => { scope.editMode = false; },
                        (response: any) => {
                            scope.ngModel[attrs.iioEditableField] = originalValue;
                            revertAndClose();
                            const errorMsg = response?.data?.errors?.[0]?.defaultMessage || "Unable to update this value right now. Please try again.";
                            showError("Unable to rename", errorMsg);
                        }
                    );
                };

                element.find("i").detach().appendTo(element.parent()).click(() => {
                    scope.editMode = true;
                    element.find("input").focus();
                });

                element.find("input").click((e: JQueryEventObject) => {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                });
            };
        }
    }

    frontendApp.directive("iioEditableFieldService", [Factory.Create(EditableFieldService)]);
    frontendApp.directive("iioEditableField", ['$injector', 'NotificationService', Factory.Create(EditableField)]);
}
